import { FC, ReactNode } from 'react'
import { Upload, Uploaded } from '@/ui/components'
import { SideoverState } from '@/states'

const File: FC<FileComponentProps> = (props): ReactNode => {
    const {
        target,
        icon,
        label,
        required,
        validationFunction
    } = props

    const { Errors, Form, Loading } = SideoverState()

    const validation: ValidationFunctionObjectReturnTypes = validationFunction(Form[target])

    return (
        <div className='select-none flex flex-col w-full' style={Loading ? { opacity: '0.75', pointerEvents: 'none' } : { opacity: '1', pointerEvents: 'auto' }}>
            <label className='select-none block mb-1 text-[13px] font-medium text-[#97999b]'>
                {label}

                {
                    required &&
                    <span className='text-red-400 ml-1 text-[12px]'>
                        *
                    </span>
                }
            </label>

            <Upload icon={icon} target={target} />
            <Uploaded target={target} />

            <p style={validation?.error && Errors?.Image ? { opacity: '1' } : { opacity: '0' }} className='text-xs h-6 mt-[2px] ml-[2px] text-red-500 transition-all duration-500 ease-in-out'>
                {validation?.message}
            </p>
        </div>
    )
}

export default File
